import { lazy } from "react";

const Information = lazy(() => import("@views/Finance/Information"))
const Stock = lazy(() => import("@views/Finance/Stock"))

const FinanceRoutes = [
    {
        path: 'finance/information/',
        element: <Information />
    },
    {
        path: 'finance/stock/',
        element: <Stock />
    },
]

export default FinanceRoutes
